import { Product } from '@/models/accounting/Product'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<Product>(Product, {
	namespaced: true
})
